export const productSpecificationsDe = {
  admin: {
    nav: 'Produktspezifikationen',
    title: 'Produktspezifikationen',
    description:
      'Wiederverwendbare Eigenschaften, Schemata, Erklärungen und versionierte PDF-Layouts definieren.',
  },
  tabs: {
    schemas: 'Schemata',
    properties: 'Eigenschaftsbibliothek',
    units: 'Einheiten',
    pdfTemplates: 'PDF-Layouts',
    declarations: 'Erklärungen',
    settings: 'Einstellungen',
  },
  actions: {
    create: 'Spezifikation anlegen',
    openRevision: 'Revision öffnen',
    backToOverview: 'Zurück zur Übersicht',
    backToProduct: 'Zurück zum Artikel',
    preview: 'Vorschau',
    publish: 'Veröffentlichen',
    validate: 'Validieren',
    submit: 'Zur Prüfung einreichen',
    requestChanges: 'Änderungen anfordern',
    approve: 'Freigeben',
    withdraw: 'Zurückziehen',
    generatePdf: 'PDF erzeugen',
    download: 'Herunterladen',
    addRow: 'Zeile hinzufügen',
    moveUp: 'Nach oben',
    moveDown: 'Nach unten',
  },
  fields: {
    name: 'Name',
    translatedName: 'Übersetzter Name',
    title: 'Titel',
    text: 'Text',
    key: 'Technischer Schlüssel',
    type: 'Typ',
    description: 'Beschreibung',
    schema: 'Schema',
    revision: 'Revision',
    version: 'Version',
    validity: 'Gültigkeit',
    validFrom: 'Gültig ab',
    changeReason: 'Änderungsgrund',
    reason: 'Begründung',
    translationStatus: 'Übersetzungsstatus',
    sectionKey: 'Abschnittsschlüssel',
    sectionTitle: 'Abschnittstitel',
    columns: 'Spalten',
    pageBreakBefore: 'Seitenumbruch davor',
    required: 'Pflichtfeld',
    dimension: 'Dimension',
    defaultUnit: 'Standardeinheit',
    translatable: 'Übersetzbar',
    sensitive: 'Sensibel',
    reportable: 'Auswertbar',
    symbol: 'Symbol',
    decimalPlaces: 'Dezimalstellen',
    conversionFactor: 'Umrechnungsfaktor',
    conversionOffset: 'Umrechnungsoffset',
    currency: 'Währung',
    minimum: 'Mindestwert',
    maximum: 'Höchstwert',
    value: 'Wert',
    unit: 'Einheit',
    tolerance: 'Toleranz',
    toleranceType: 'Toleranzart',
    measurementMethod: 'Messmethode',
    remark: 'Bemerkung',
    referenceIds: 'Interne Referenzen, kommagetrennt',
    declarationVersionId: 'Erklärungsversion',
    confirmed: 'Bestätigt',
    confirmationRequired: 'Bestätigung erforderlich',
  },
  values: {
    none: 'Keine',
    required: 'Pflichtfeld',
    openEnded: 'unbefristet',
    yes: 'Ja',
    no: 'Nein',
  },
  toleranceTypes: { ABSOLUTE: 'Absolut', PERCENT: 'Prozentual' },
  states: {
    loadError: 'Die Spezifikationsdaten konnten nicht geladen werden.',
    emptyTitle: 'Noch keine Spezifikationen',
    emptyDescription:
      'Legen Sie aus einem veröffentlichten Schema eine kontrollierte Produktspezifikation an.',
    noRevision: 'Es ist keine Revision vorhanden.',
  },
  product: {
    title: 'Produktspezifikationen',
    description: 'Versionierte, mehrsprachige und kontrolliert freigegebene Produktinformationen.',
  },
  create: {
    title: 'Produktspezifikation anlegen',
    description: 'Wählen Sie ein veröffentlichtes Schema und definieren Sie die erste Revision.',
    selectSchema: 'Schema auswählen',
    success: 'Spezifikation angelegt.',
    error: 'Spezifikation konnte nicht angelegt werden.',
  },
  property: {
    title: 'Eigenschaftsbibliothek',
    description: 'Wiederverwendbare typisierte Definitionen für jede Branche.',
    add: 'Eigenschaft hinzufügen',
    empty: 'Es sind noch keine Eigenschaften definiert.',
    createSuccess: 'Eigenschaft angelegt.',
    createError: 'Eigenschaft konnte nicht angelegt werden.',
    types: {
      SHORT_TEXT: 'Kurzer Text',
      MULTILINE_TEXT: 'Mehrzeiliger Text',
      RICH_TEXT: 'Sicherer Langtext',
      INTEGER: 'Ganzzahl',
      DECIMAL: 'Dezimalzahl',
      PERCENT: 'Prozent',
      CURRENCY: 'Währung',
      BOOLEAN: 'Boolean',
      DATE: 'Datum',
      DATE_TIME: 'Datum und Uhrzeit',
      SINGLE_CHOICE: 'Einfachauswahl',
      MULTIPLE_CHOICE: 'Mehrfachauswahl',
      TRANSLATABLE_CHOICE: 'Übersetzbare Auswahl',
      MEASUREMENT: 'Wert mit Einheit',
      RANGE: 'Wertebereich',
      MINIMUM: 'Mindestwert',
      MAXIMUM: 'Höchstwert',
      TARGET_TOLERANCE: 'Zielwert mit Toleranz',
      COMPARISON_MEASUREMENT: 'Messwert mit Operator',
      FORMULA: 'Formel',
      IMAGE: 'Bild',
      IMAGE_GALLERY: 'Bildergalerie',
      DMS_FILE: 'DMS-Datei',
      CERTIFICATE: 'Zertifikatsreferenz',
      PRODUCT_REFERENCE: 'Produktreferenz',
      URL: 'URL',
      KEY_VALUE_TABLE: 'Schlüssel-Wert-Tabelle',
      CUSTOM_TABLE: 'Freie Tabelle',
      MATRIX: 'Matrix',
      LIST: 'Liste',
      NUMBERED_INSTRUCTIONS: 'Nummerierte Anleitung',
      DECLARATION: 'Erklärung',
      SECTION_HEADING: 'Abschnittsüberschrift',
      INFORMATION: 'Informationstext',
    },
    configuration: {
      SINGLE_CHOICE: 'Erste Option',
      MULTIPLE_CHOICE: 'Erste Option',
      TRANSLATABLE_CHOICE: 'Erste Option',
      FORMULA: 'Formelausdruck',
      KEY_VALUE_TABLE: 'Erste Spalte',
      CUSTOM_TABLE: 'Erste Spalte',
      MATRIX: 'Erste Spalte',
    },
  },
  unit: {
    title: 'Einheitenbibliothek',
    description: 'Mandantenbezogene Dimensionen und exakte Decimal-Umrechnungen.',
    add: 'Einheit hinzufügen',
    createSuccess: 'Einheit angelegt.',
    createError: 'Einheit konnte nicht angelegt werden.',
  },
  schema: {
    title: 'Spezifikationsschemata',
    description:
      'Versionierte Erfassungsmasken aus wiederverwendbaren Eigenschaften zusammenstellen.',
    add: 'Schema anlegen',
    empty: 'Es sind noch keine Schemata definiert.',
  },
  builder: {
    library: 'Eigenschaftsbibliothek',
    inspector: 'Inspector',
    addProperty: '{{name}} hinzufügen',
    dropHint: 'Eigenschaft hier ablegen oder die Hinzufügen-Schaltfläche verwenden.',
    addSection: 'Abschnitt hinzufügen',
    saveSuccess: 'Schemaentwurf gespeichert.',
    saveError: 'Schema konnte nicht gespeichert werden.',
    versionSuccess: 'Neue Schemaversion angelegt.',
    draftAlreadyExists: 'Es existiert bereits eine Entwurfsversion.',
    validationError: 'Prüfen Sie alle Pflichtschlüssel, Übersetzungen und Konfigurationen.',
    publishSuccess: 'Schema veröffentlicht.',
    publishError: 'Schema konnte nicht veröffentlicht werden.',
    validationIssues: 'Es sind noch {{count}} Validierungsfehler vorhanden.',
  },
  editor: {
    saved: 'Gespeichert',
    unsaved: 'Änderungen speichern',
    saveError:
      'Änderungen konnten nicht gespeichert werden. Laden Sie vor dem Überschreiben paralleler Änderungen neu.',
    completeness: 'Vollständigkeit',
    contents: 'Inhalt',
    validationSummary: 'Validierungsfehler',
    sourceText: 'Quelltext',
    language: 'Sprache',
    workflow: 'Prüfung und Freigabe',
    pdf: 'PDF-Dokumente',
    valid: 'Die Revision ist gültig.',
  },
  sources: {
    type: 'Datenquelle',
    field: 'Quellfeld',
    key: 'Quellschlüssel',
    imageVariant: 'Bildvariante',
    packagingId: 'Verpackungs-ID (optional)',
    automaticSelection: 'Automatisch auswählen',
    dmsCategory: 'DMS-Kategorie',
    expression: 'Formelausdruck',
    market: 'Markt',
    parameterKey: 'Analyseschlüssel (optional)',
    domainKey: 'Analysedomäne',
    allParameters: 'Alle Parameter als Tabelle',
    display: 'Darstellung',
    snapshotOnCreate: 'Quelle beim Anlegen einfrieren',
    refreshOnRevision: 'Bei neuer Revision aktualisieren',
    copyInitially: 'Initialwert übernehmen',
    showLiveInDraft: 'Live-Quelle im Entwurf anzeigen',
    readOnly: 'Schreibgeschützt',
    manuallyOverridable: 'Begründeten Override erlauben',
    refresh: 'Quelldaten aktualisieren',
    refreshSuccess: 'Quelldaten und Herkunftsnachweise wurden aktualisiert.',
    refreshError: 'Quelldaten konnten nicht aktualisiert werden.',
    warningTitle: 'Unvollständige oder widersprüchliche Quelldaten',
    warningItem: 'Quellfeld „{{field}}“ ist unvollständig ({{code}}).',
    overrideReason: 'Begründung für den manuellen Override',
    overrideReasonRequired:
      'Eine Begründung ist für rechtssichere Nachvollziehbarkeit erforderlich.',
    overrideReasonSaved: 'Gespeicherte Override-Begründung: {{reason}}',
    provenance: 'Quelle: {{source}} · Version: {{version}}',
    snapshot: 'eingefrorener Snapshot',
    types: {
      MANUAL: 'Manuelle Eingabe',
      PRODUCT_FIELD: 'Artikelstamm',
      PRODUCT_CUSTOM_FIELD: 'Benutzerdefiniertes Artikelfeld',
      PRODUCT_CATEGORY: 'Artikelkategorie',
      PRODUCT_IMAGE: 'Produktbild',
      PACKAGING: 'Verpackungsdaten',
      DMS_ATTACHMENT: 'DMS-Anhang',
      FORMULA: 'Formel',
      RECIPE: 'Freigegebene Rezeptur',
      PRODUCT_DECLARATION: 'Freigegebene Deklaration',
      ALLERGEN: 'Allergendaten',
      NUTRITION: 'Nährwerte',
      PROCESS_ROUTING: 'Freigegebener Prozess',
      YIELD: 'Ausbeute',
      ANALYSIS: 'Analysewerte',
      MATERIAL_PROFILE: 'Materialstamm',
    },
    origins: { MANUAL: 'Manuell', AUTOMATIC: 'Automatisch', MANUAL_OVERRIDE: 'Manueller Override' },
    values: {
      articleNumber: 'Artikelnummer',
      name: 'Bezeichnung',
      description: 'Beschreibung',
      ean: 'EAN',
      manufacturerNumber: 'Herstellernummer',
      weightNetKg: 'Nettogewicht',
      weightGrossKg: 'Bruttogewicht',
      countryOfOrigin: 'Ursprungsland',
      THUMBNAIL: 'Miniaturansicht',
      LIST: 'Listenansicht',
      CATALOG: 'Katalogansicht',
      DETAIL: 'Detailansicht',
      ALL: 'Alle',
      GENERAL_FILE: 'Allgemeine Datei',
      CERTIFICATE: 'Zertifikat',
      DATASHEET: 'Datenblatt',
      NUMBER: 'Nummer',
      NAME: 'Bezeichnung',
      DESCRIPTION: 'Beschreibung',
      BASE_QUANTITY: 'Referenzmenge',
      BASE_UNIT: 'Basiseinheit',
      COMPONENTS: 'Komponenten',
      INTERNAL_MATERIAL_COST: 'Interne Materialkosten',
      DMS_ATTACHMENTS: 'DMS-Dokumente',
      PRODUCT_DESIGNATION: 'Produktbezeichnung',
      INGREDIENT_TEXT: 'Zutatenverzeichnis',
      ALLERGEN_TEXT: 'Allergenhinweis',
      ADDITIVE_TEXT: 'Zusatzstoffangaben',
      WARNING_TEXT: 'Warnhinweise',
      COMBINED_TEXT: 'Kombinierter Deklarationstext',
      STEPS: 'Prozessschritte',
      INSTRUCTIONS: 'Arbeitsanweisungen',
      QUALITY_CHECKS: 'Qualitätsprüfungen',
      PHOTOS: 'Prozessfotos',
      PERCENT: 'Prozent',
      FACTOR: 'Faktor',
      STANDARD_UNIT: 'Standardmengeneinheit',
      DENSITY: 'Dichte',
      ORIGIN: 'Herkunft',
      MANUFACTURER: 'Hersteller',
      TECHNICAL_PROPERTIES: 'Technische Eigenschaften',
      QUALITY_PROPERTIES: 'Qualitätseigenschaften',
      STORAGE_CONDITIONS: 'Lagerbedingungen',
      STORAGE_INSTRUCTIONS: 'Lagerhinweise',
      SHELF_LIFE_DAYS: 'Haltbarkeit in Tagen',
    },
  },
  impact: {
    title: 'Erneute Prüfung erforderlich',
    description:
      'Freigegebene Quelldaten haben sich geändert. Prüfen Sie die Auswirkungen vor der nächsten Freigabe.',
    badge: 'Prüfung erforderlich',
    count: '{{count}} Quellenänderungen betreffen diese Spezifikation.',
    item: 'Die Quelle „{{source}}“ wurde geändert.',
  },
  workflow: {
    submitted: 'Revision zur Prüfung eingereicht.',
    changesRequested: 'Änderungen angefordert.',
    approved: 'Revision freigegeben.',
    published: 'Revision veröffentlicht.',
    withdrawn: 'Revision zurückgezogen.',
    error: 'Workflow-Aktion fehlgeschlagen.',
  },
  revisionTools: {
    title: 'Revision und Schemaversion',
    createNext: 'Neue Revision erzeugen',
    created: 'Eine neue Revision wurde angelegt.',
    createError: 'Die neue Revision konnte nicht angelegt werden.',
    compare: 'Mit Revision vergleichen',
    selectRevision: 'Revision auswählen',
    changeCount: '{{count}} Änderungen',
    noChanges: 'Es wurden keine Unterschiede gefunden.',
    changeKind: { ADDED: 'Hinzugefügt', REMOVED: 'Entfernt', CHANGED: 'Geändert' },
    migration: 'Kontrollierte Schemamigration',
    selectSchemaVersion: 'Veröffentlichte Schemaversion auswählen',
    migrate: 'Migrierte Revision anlegen',
    migrated: 'Die migrierte Entwurfsrevision wurde angelegt.',
    migrationError: 'Die Revision konnte nicht migriert werden.',
    migrationCategory: {
      unchanged: 'Unveränderte Felder',
      new: 'Neue Felder',
      removed: 'Entfernte Felder',
      incompatible: 'Inkompatible Felder',
      carriable: 'Übernehmbare Werte',
      manual: 'Manuell zu prüfen',
    },
  },
  settings: {
    title: 'Spezifikationseinstellungen',
    description: 'Mandantenweite Vorgaben für Freigabe, Gültigkeit und sichere PDF-Dateinamen.',
    defaultSourceLocale: 'Standard-Quellsprache',
    validityWarningDays: 'Gültigkeitswarnung (Tage)',
    fileNamePattern: 'PDF-Dateinamensmuster',
    fileNamePatternHelp:
      'Verfügbare Platzhalter: {{articleNumber}}, {{specificationKey}}, {{revision}}, {{locale}}.',
    requireFourEyes: 'Vier-Augen-Freigabe standardmäßig verlangen',
    creatorMayApprove: 'Freigabe durch den Ersteller erlauben',
    createPdfOnPublish: 'PDFs bei Veröffentlichung erzeugen',
    saved: 'Spezifikationseinstellungen gespeichert.',
    saveError: 'Spezifikationseinstellungen konnten nicht gespeichert werden.',
  },
  declaration: {
    title: 'Erklärungen und Zertifikate',
    description: 'Rechtliche und branchenspezifische Texte als konfigurierbare Versionen pflegen.',
    createSuccess: 'Erklärung angelegt.',
    createError: 'Erklärung konnte nicht angelegt werden.',
    publishSuccess: 'Erklärung veröffentlicht.',
    publishError: 'Erklärung konnte nicht veröffentlicht werden.',
  },
  pdf: {
    title: 'Spezifikations-PDF-Designer',
    description: 'Eigene dynamische Layoutdomäne auf der gemeinsamen PDF-Grundlage.',
    blockLibrary: 'Blockbibliothek',
    inspector: 'Seiten-Inspector',
    blockText: 'Übersetzter Blocktext',
    addBlock: 'Block hinzufügen',
    pagePreview: 'Druckseitenvorschau',
    createSuccess: 'PDF-Layout angelegt.',
    createError: 'PDF-Layout konnte nicht angelegt werden.',
    publishSuccess: 'PDF-Layout veröffentlicht.',
    publishError: 'PDF-Layout konnte nicht veröffentlicht werden.',
    previewError: 'PDF-Vorschau fehlgeschlagen.',
    previewTitle: 'Vorschau des Spezifikations-PDFs',
    queued: 'PDF-Erzeugung wurde eingereiht.',
    combined: 'Kombinierte Sprachen',
    attachments: 'Optionale Anlagen aus dem DMS',
    attachmentCount: '{{count}} eingefrorene Anlagen',
    generateCombined: 'Mehrsprachiges Gesamtdokument',
    versionCount: '{{count}} Versionen',
    status: {
      PENDING: 'Eingereiht',
      PROCESSING: 'Wird erzeugt',
      READY: 'Bereit',
      FAILED: 'Fehlgeschlagen',
    },
    blocks: {
      COMPANY_LOGO: 'Firmenlogo',
      COMPANY_ADDRESS: 'Firmenanschrift',
      DOCUMENT_TITLE: 'Dokumenttitel',
      PRODUCT_NAME: 'Produktname',
      ARTICLE_NUMBER: 'Artikelnummer',
      PRODUCT_CATEGORY: 'Produktkategorie',
      PRODUCT_IMAGE: 'Produktbild',
      IMAGE_GALLERY: 'Bildergalerie',
      SPECIFICATION_NUMBER: 'Spezifikationsnummer',
      REVISION_NUMBER: 'Revisionsnummer',
      STATUS: 'Status',
      VALIDITY_DATE: 'Gültigkeit',
      CREATED_DATE: 'Erstellungsdatum',
      APPROVED_DATE: 'Freigabedatum',
      SECTION: 'Spezifikationsabschnitt',
      PROPERTY: 'Eigenschaft',
      PROPERTY_GROUP: 'Eigenschaftsgruppe',
      DYNAMIC_TABLE: 'Dynamische Tabelle',
      MATRIX: 'Matrix',
      LONG_TEXT: 'Langtext',
      NOTICE: 'Hinweisbox',
      CERTIFICATE_LIST: 'Zertifikatsliste',
      DMS_FILE_LIST: 'DMS-Dateiliste',
      ATTACHMENT_LIST: 'Anlagenverzeichnis',
      APPROVAL: 'Freigabeblock',
      REVISION_HISTORY: 'Revisionshistorie',
      TABLE_OF_CONTENTS: 'Inhaltsverzeichnis',
      HEADER: 'Seitenkopf',
      FOOTER: 'Seitenfuß',
      PAGE_NUMBER: 'Seitenzahl',
      CONFIDENTIALITY: 'Vertraulichkeitskennzeichen',
      WATERMARK: 'Wasserzeichen',
      QR_CODE: 'Verifikations-QR-Code',
      STATIC_TEXT: 'Statischer übersetzbarer Text',
      CONDITIONAL: 'Bedingter Block',
    },
  },
  status: {
    schema: { NEW: 'Neu', DRAFT: 'Entwurf', PUBLISHED: 'Veröffentlicht', ARCHIVED: 'Archiviert' },
    revision: {
      DRAFT: 'Entwurf',
      IN_REVIEW: 'In Prüfung',
      CHANGES_REQUESTED: 'Änderungen angefordert',
      APPROVED: 'Freigegeben',
      PUBLISHED: 'Veröffentlicht',
      SUPERSEDED: 'Ersetzt',
      WITHDRAWN: 'Zurückgezogen',
    },
    translation: {
      NOT_STARTED: 'Nicht begonnen',
      IN_PROGRESS: 'In Bearbeitung',
      IN_REVIEW: 'In Prüfung',
      APPROVED: 'Freigegeben',
    },
  },
  operators: {
    EQUAL: '=',
    LESS_THAN: '<',
    LESS_THAN_OR_EQUAL: '≤',
    GREATER_THAN: '>',
    GREATER_THAN_OR_EQUAL: '≥',
    RANGE: 'Bereich',
    APPROXIMATELY: 'Ungefähr',
    NOT_DETECTABLE: 'Nicht nachweisbar',
    PASSED: 'Bestanden',
    FAILED: 'Nicht bestanden',
  },
} as const;
